import { OnInit, EventEmitter } from '@angular/core';
var SearchableDropdownComponent = /** @class */ (function () {
    function SearchableDropdownComponent() {
        this.selectedDropDowns = new EventEmitter();
    }
    SearchableDropdownComponent.prototype.compareFn = function (val1, val2) {
        return val1.toString() === val2.toString();
    };
    SearchableDropdownComponent.prototype.ngOnInit = function () {
        // console.log('multiselect : ', this.dropdownData);
        // this.dropdownData = {
        //     type : 'searchable-dropdown',
        //     title : 'City',
        //     values : ['Bangalore', 'Hyderabad', 'Mumbai', 'Ahmedabad'],
        //     default : '',
        //     key : 'city-dropdown'
        //   };
    };
    SearchableDropdownComponent.prototype.chosenOptions = function () {
        var _a;
        var emitSelections = (_a = {},
            _a[this.dropdownData.key] = this.selectedValues,
            _a);
        this.selectedDropDowns.emit(emitSelections);
    };
    return SearchableDropdownComponent;
}());
export { SearchableDropdownComponent };
